import { defineMessages } from "react-intl";

export const formsLinkedRecordGridText = defineMessages({
  newRecordForTerm: {
    defaultMessage: "New {recordTerm}",
    id: "DXSSNm",
  },
  unlinkRecord: {
    defaultMessage: "Unlink record",
    id: "rlTe6o",
  },
  linkToTable: {
    defaultMessage: "Link to {table}",
    id: "6h5bbl",
  },
  noAccessToLinkedTable: {
    defaultMessage: "You don't have access to this linked Table",
    id: "Qgjjf/",
  },
});
